export default "__VITE_ASSET__zLZuEBnR__"